import api from "./api";
import {
  ProductionOrderCommand,
  ProductionOrderItemCommand,
  ProductionOrderQuery,
} from "../models/Production";

export const getBoard = async (filter?: ProductionOrderQuery) => {
  try {
    const response = await api.get(`/api/production/board`, {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const saveRow = async (command: ProductionOrderCommand) => {
  try {
    const response = await api.post(`/api/production`, command);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateRow = async (id: string, command: ProductionOrderCommand) => {
  try {
    const response = await api.put(`/api/production/${id}`, command);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteRow = async (id: string) => {
  try {
    const response = await api.delete(`/api/production/${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateField = async (
  id: string,
  fieldName: string,
  value: any,
) => {
  try {
    const response = await api.patch(`/api/production/updateField`, {
      id,
      fieldName,
      value,
    });
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const importItemsAI = async (file: File, id: string) => {
  try {
    let formData = new FormData();
    formData.append("file", new File([file], file.name));
    const response = await api.post(
      `/api/production/${id}/saveItems`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const saveItems = async (
  id: string,
  items: ProductionOrderItemCommand[],
) => {
  try {
    const response = await api.put(`/api/production/${id}/items`, items);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const uploadDocument = async (file: File, id: string) => {
  try {
    let formData = new FormData();
    formData.append("file", new File([file], file.name));
    const response = await api.post(
      `/api/production/${id}/document`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const exportExcel = async (filter?: ProductionOrderQuery) => {
  try {
    const response = await api.post(`/api/production/export`, filter);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};
